<template>
  <footer class="bg-jade-900 text-white/60 text-center mt-10">
    <div class="container sm:divide-x sm:divide-white/50 sm:flex sm:items-center sm:justify-center py-4 space-y-6">
      <div class="flex flex-col items-center px-5">
        <img src="/img/logos/logo-white.svg" class="w-40" alt="True Market Insiders' logo">
        <div class="flex justify-center space-x-6">
          <a v-for="item in social" :key="item.key" :href="item.path" class="text-inherit hover:text-white/80" target="_blank">
            <span class="sr-only">{{ labelService.label( item.key ) }}</span>
            <i :class="`pi ${item.icon}`"></i>
          </a>
        </div>
      </div>
      <div class="sm:text-left px-5">
        <div class="mb-4">
          <router-link :to="contactUsPath" class="text-white/80 uppercase font-bold">Contact Us</router-link>
        </div>
        <div class="text-sm">
          <a href="tel:+18558220269" class="font-semibold text-inherit hover:text-white/80">(855) 822-0269</a> (U.S. & Canada)<br>
          <a href="tel:+15612061207" class="font-semibold text-inherit hover:text-white/80">+1 561-206-1207</a> (International)

          <div class="mt-2">
            <a href="mailto:support@truemarketinsiders.com" target="_blank" class="font-semibold text-inherit hover:text-white/80">support@truemarketinsiders.com</a></div>
        </div>
      </div>
    </div>
    <div class="bg-black py-4">
      <nav class="mb-4 sm:flex sm:justify-center sm:space-x-12" aria-label="Footer">
        <div v-for="item in legal" :key="item.key">
          <router-link :to="item.path" class="text-sm text-white/70 hover:text-white/90">{{ labelService.label( item.key ) }}</router-link>
        </div>
      </nav>
      <p class="text-xs mb-0">v{{ currentVersion }} © True Market Insiders 2016-{{ new Date().getFullYear() }}. All rights reserved.</p>
    </div>
  </footer>
</template>

<script setup lang="ts">
import type { LabelService } from "@/composables/label-service";

const labelService = inject< LabelService >( labelServiceSymbol ) as LabelService;

import routeManager from "@/router/route-manager";
import { useVersionInfo } from "@/services/version-service";
import { computed, inject } from "vue";
import { labelServiceSymbol } from "@/plugins/LabelServicePlugin";

const { currentVersion } = useVersionInfo();
const legal = computed( () => routeManager.legalNavigation() );
const social = computed( () => routeManager.socialNavigation() );
const contactUsPath = computed( () => routeManager.contactUsPath() );
</script>